"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const window_or_global_1 = __importDefault(require("window-or-global"));
const Url_1 = __importDefault(require("../constants/Url"));
const InviteActions_1 = __importDefault(require("../actions/InviteActions"));
/**
 * InviteSource
 *
 */
const xhr = {
    getHeader: {
        'X-Requested-With': 'XMLHttpRequest',
        'X-EPIC-RETURN-JSON-IF-NO-AUTH': true
    },
    postHeader: {
        'X-Requested-With': 'XMLHttpRequest'
    }
};
const InviteSource = {
    getCurrentInvites: {
        remote(state) {
            return axios_1.default.get(Url_1.default().INVITE.GETINVITES, {
                headers: xhr.getHeader
            });
        },
        success: InviteActions_1.default.getCurrentInvitesSuccess,
        error: InviteActions_1.default.getCurrentInvitesFailure,
        shouldFetch() {
            return !window_or_global_1.default.__server_side_render;
        }
    },
    sendInvite: {
        remote(state, email) {
            return axios_1.default.post(Url_1.default().INVITE.SENDINVITE, { email }, {
                headers: xhr.getHeader
            });
        },
        success: InviteActions_1.default.sendInviteSuccess,
        error: InviteActions_1.default.sendInviteFailure,
        shouldFetch() {
            return !window_or_global_1.default.__server_side_render;
        }
    }
};
exports.default = InviteSource;
//# sourceMappingURL=InviteSource.js.map